import React, { useState, useEffect } from "react";
import { Button } from 'antd';
// import { Document, Page, pdfjs } from 'react-pdf';
// import * as XLSX from 'xlsx';
import styles from './viewFile.module.less';
import { downloadFile } from "@/api/dictionary";
import { useTranslation } from 'react-i18next';

// 配置 PDF worker
// pdfjs.GlobalWorkerOptions.workerSrc = '../../../../../public/js/pdf.worker.min.js';
// pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.js`;

interface KnowledgeItem {
    id: string;
    name: string;
    isHome?: boolean;
    downloadAddress: string | null;
    downloadAddressAll: string | null;
    fileInfoId: string;
}
interface ViewFileProps {
    fileType?: string;
    file: KnowledgeItem;
}

// type ExcelRow = (string | number | null)[];

const ViewFile: React.FC<ViewFileProps> = ({ file }) => {
    const { t } = useTranslation();
    const fileType = file?.downloadAddress?.split('.')[1] === 'pdf' ? 'pdf' : 'other'
    
    // const [numPages, setNumPages] = useState(0);
    // const [pageNumber, setPageNumber] = useState(1);
    // const [excelData, setExcelData] = useState<ExcelRow[]>([]);
    const [fileData, setFileData] = useState('');
    const [loading,setLoading] = useState(false)
    // const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    //     setNumPages(numPages);
    //     setLoading(false);
    // };

    // 处理文件加载
    const handleFileLoad = async (url) => {
        if (fileType === 'pdf') {
            setFileData(url);
        } else {
            try{
                setLoading(true)
                const response = await downloadFile({
                    downloadAddress: url,
                }) as any;
                
                // 获取文件后缀
                const fileName = file.name || 'download';
                const fileExtension = file.downloadAddress?.split('.').pop() || '';
                
                const blob = new Blob([response], { type: 'application/octet-stream' });
                const downloadUrl = URL.createObjectURL(blob);
                
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `${fileName}${fileExtension ? `.${fileExtension}` : ''}`;
                document.body.appendChild(link);
                link.click();
                
                document.body.removeChild(link);
                URL.revokeObjectURL(downloadUrl);
            }finally{
                setLoading(false)
            }
        }
    };

    // 清理 URL 对象
    // useEffect(() => {
    //     return () => {
    //         if (fileData && fileType === 'pdf') {
    //             URL.revokeObjectURL(fileData);
    //         }
    //     };
    // }, [fileData, fileType]);

    useEffect(() => {
        if (file.downloadAddressAll && fileType === 'pdf') {
            handleFileLoad(file.downloadAddressAll);
        }
    }, [file, fileType]);

    const renderFilePreview = () => {
        if (!file) {
            return <div>无文件</div>;
        }

        switch (fileType) {
            case 'pdf':
                return (
                    <div className={styles.pdfContainer}>
                        <embed src={fileData} style={{ width: '100%', height: `${window.innerHeight - 200}px` }}></embed>
                        {/* <Document
                            file={fileData}
                            onLoadSuccess={onDocumentLoadSuccess}
                            loading={<Spin />}
                            error={<div>PDF 加载失败，请重试</div>}
                        >
                            <Page
                                pageNumber={pageNumber}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                                error={<div>页面加载失败，请重试</div>}
                            />
                        </Document>
                        {numPages > 0 && (
                            <div className={styles.pdfPagination}>
                                <div className={styles.pageControls}>
                                    <button
                                        onClick={() => setPageNumber(prev => Math.max(1, prev - 1))}
                                        disabled={pageNumber <= 1}
                                    >
                                        上一页
                                    </button>
                                    <span>
                                        第 {pageNumber} 页，共 {numPages} 页
                                    </span>
                                    <button
                                        onClick={() => setPageNumber(prev => Math.min(numPages, prev + 1))}
                                        disabled={pageNumber >= numPages}
                                    >
                                        下一页
                                    </button>
                                </div>
                            </div>
                        )} */}
                    </div>
                )

            // case 'excel':
            //     return excelData.length > 0 ? (
            //         <div className={styles.excelContainer}>
            //             <table className={styles.excelTable}>
            //                 <thead>
            //                     <tr>
            //                         {excelData[0]?.map((cell, index) => (
            //                             <th key={index}>{cell?.toString()}</th>
            //                         ))}
            //                     </tr>
            //                 </thead>
            //                 <tbody>
            //                     {excelData.slice(1).map((row, rowIndex) => (
            //                         <tr key={rowIndex}>
            //                             {row.map((cell, cellIndex) => (
            //                                 <td key={cellIndex}>{cell?.toString()}</td>
            //                             ))}
            //                         </tr>
            //                     ))}
            //                 </tbody>
            //             </table>
            //         </div>
            //     ) : (
            //         <div>无数据</div>
            //     );

            default:
                return (
                    <div className={styles.download}>
                        <div>{t('ikg.unSupport')}</div>
                        <Button type="primary" loading={loading} onClick={() => handleFileLoad(file.downloadAddress)}>{t('ikg.downloadFile')}</Button>
                    </div>
                );
        }
    };

    return (
        <div className={styles.viewFile}>
            {renderFilePreview()}
        </div>
    );
};

export default ViewFile;